import React from 'react';
import { Link } from 'react-router-dom';
import { FaUser } from 'react-icons/fa';

import { ROUTE_PREFIX } from '../../constants/router';
import { clearExportSnapshots } from '../../util/exportSnapshots';
import ConfirmClearExportsModal from './ConfirmClearExportsModal';

import s from './SettingsMenu.module.scss';

interface SettingsMenuProps {
  meData?: any;
  finishedTest?: boolean;
  onLogout: () => void;
  showShareOption?: boolean;
  withEPortfolio?: boolean;
  // eslint-disable-next-line no-unused-vars
  onShare?: (data: any) => void;
}

class SettingsMenu extends React.Component<SettingsMenuProps> {
  static defaultProps = {
    finishedTest: true,
    meData: null,
    showShareOption: false,
    withEPortfolio: false,
    onShare: () => {},
  };

  // eslint-disable-next-line react/state-in-constructor
  state: { showClearExportsModal: boolean };

  constructor(props: any) {
    super(props);
    this.state = { showClearExportsModal: false };
    this.renderLoginLogoutButton = this.renderLoginLogoutButton.bind(this);
    this.openClearExportsModal = this.openClearExportsModal.bind(this);
    this.closeClearExportsModal = this.closeClearExportsModal.bind(this);
    this.clearExports = this.clearExports.bind(this);
  }

  openClearExportsModal() {
    this.setState({ showClearExportsModal: true });
  }

  closeClearExportsModal() {
    this.setState({ showClearExportsModal: false });
  }

  clearExports() {
    clearExportSnapshots();
    this.setState({ showClearExportsModal: false });

    if (window.location.pathname === `${ROUTE_PREFIX}/exports`) {
      window.location.reload();
    }
  }

  renderLoginLogoutButton() {
    const { meData } = this.props;
    const loggedInUser = meData && meData.me;
    const username = loggedInUser ? loggedInUser.name : null;
    if (username) {
      return (
        <button
          type="button"
          className={`${s.menuItem} ${s.logoutItem}`}
          onClick={this.props.onLogout}
        >
          {/* eslint-disable-next-line */}
          Logout (<FaUser style={{ padding: '1px 0 4px' }} /> {username})
        </button>
      );
    }
    return (
      <Link
        to={`${ROUTE_PREFIX}/login`}
        className={`${s.menuItem} ${s.logoutItem}`}
        onClick={this.props.onLogout}
      >
        <p style={{ paddingTop: '10px' }}>
          Anmelden
          <FaUser style={{ marginLeft: '5px', padding: '1px 0 4px' }} />
        </p>
      </Link>
    );
  }

  render() {
    const { finishedTest, showShareOption, onShare, withEPortfolio } =
      this.props;

    const logoutLoginButton = this.renderLoginLogoutButton();
    return (
      <div className={s.menuContainer}>
        <ConfirmClearExportsModal
          showModal={this.state.showClearExportsModal}
          clearExports={this.clearExports}
          closeModal={this.closeClearExportsModal}
        />
        <div className={s.menuBody}>
          {finishedTest && (
            <Link to={`${ROUTE_PREFIX}/results-explanation`}>
              <p className={s.menuItem}>Erklärung der Ergebnisse</p>
            </Link>
          )}
          <Link to={`${ROUTE_PREFIX}/faq`}>
            <p className={s.menuItem}>FAQ</p>
          </Link>
          {showShareOption && (
            <button
              type="button"
              className={`${s.menuItem} ${s.logoutItem}`}
              onClick={() => {
                if (onShare) {
                  onShare({ withEPortfolio });
                }
              }}
            >
              {withEPortfolio ? 'Portfolio teilen' : 'Ergebnisse teilen'}
            </button>
          )}
          {finishedTest && (
            <Link to={`${ROUTE_PREFIX}/exports`}>
              <p className={s.menuItem}>Deine Exporte</p>
            </Link>
          )}
          <button
            type="button"
            className={`${s.menuItem} ${s.logoutItem}`}
            onClick={this.openClearExportsModal}
          >
            Exporte löschen
          </button>
          <Link to={`${ROUTE_PREFIX}/impressum`}>
            <p className={s.menuItem}>Impressum</p>
          </Link>
          <Link to={`${ROUTE_PREFIX}/datenschutz`}>
            <p className={s.menuItem}>Datenschutzinfo</p>
          </Link>
          {logoutLoginButton}
        </div>
        <div>
          <div className={s.triangle} />
        </div>
      </div>
    );
  }
}

export default SettingsMenu;
